// https://cmsdev.cruisecode.com/BookingPlatform/GetDTDAssignmentBookingList?companyId=72aca93d-62a8-48e8-abf5-9814dc7604ae&tourInventoryID=14846&pagination%5Bpage%5D=1&pagination%5Bperpage%5D=50&query=

export const GetDTDAssignmentBookingList = [
    {
        TourInventoryID: 14846,
        BookingId: 5338,
        FirstName: 'Jacob',
        LastName: 'Yi',
        ShipName: null,
        BookingNumber: 'KVLCQGRGDX',
        Group: '',
        Adults: 2,
        Children: 0,
        Infants: 0,
        TotalBooked: 2,
        CurrentCount: 0,
        PickUp: '',
        PhoneNumber: '19494223902',
        Notes: '',
        DockNotes: '',
        CheckedIn: '',
        WaiverCompleted: '',
        IsOTC: false,
        IsNoShow: false,
        ShowCount: 2,
        Partner_AgentName: 'Boring Company -  ',
        PartnerName: 'Boring Company',
        AgentName: ' ',
        NoShowComment: null,
    },
    {
        TourInventoryID: 14846,
        BookingId: 5385,
        FirstName: 'Robert',
        LastName: 'Murphy',
        ShipName: 'Carnival Spirit',
        BookingNumber: 'ZQ9WBAFABZ',
        Group: '',
        Adults: 4,
        Children: 3,
        Infants: 1,
        TotalBooked: 7,
        CurrentCount: 0,
        PickUp: "Corner of 2nd and Broadway (National Park Service visitor's center)",
        PhoneNumber: '19079570746',
        Notes: null,
        DockNotes: '',
        CheckedIn: '',
        WaiverCompleted: '',
        IsOTC: false,
        IsNoShow: false,
        ShowCount: 7,
        Partner_AgentName: ' -  ',
        PartnerName: null,
        AgentName: ' ',
        NoShowComment: null,
    },
];
